import React from 'react';
import {
    Button,
    Dialog,
    DialogContent,
    DialogTitle,
    IconButton,
    useMediaQuery,
    useTheme,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import PaywayPaymentForm from '../payment/PaywayPaymentForm';

// Pagar un pedido con tarjeta (Payway) sin salir de la videollamada.
//
// Es la misma página /pagar/:id?t= pero en un diálogo sobre /call: navegar a
// la página desmontaría Call.js y cortaría la sesión de OpenTok, mientras que
// un diálogo no toca nada — el asesor sigue viendo y oyendo al comprador
// mientras carga la tarjeta. En anchos de teléfono va a pantalla completa para
// que el formulario entre con el teclado.
const InCallPayDialog = ({ open, onClose, purchaseOrderId, accessToken, onApproved }) => {
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullScreen={fullScreen}
            maxWidth="sm"
            fullWidth
        >
            <DialogTitle
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    pr: 1,
                }}
            >
                Pagar con tarjeta
                <IconButton aria-label="Cerrar" onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent sx={{ bgcolor: 'grey.100' }}>
                {open && purchaseOrderId && (
                    <PaywayPaymentForm
                        purchaseOrderId={purchaseOrderId}
                        accessToken={accessToken}
                        onApproved={onApproved}
                        approvedAction={
                            <Button variant="contained" onClick={onClose}>
                                Volver a la llamada
                            </Button>
                        }
                    />
                )}
            </DialogContent>
        </Dialog>
    );
};

export default InCallPayDialog;
